module.exports = __webpack_public_path__ + "img/coming.4e7d6d20.png";